import React, { useState } from 'react';
import { Link , useLocation, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../adm_mypageAside";
import Button from 'components/buttons/';
import UIDatePicker from "components/datepicker";
import UITextArea from "components/atoms/textarea/UITextArea";
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from "utils/CommonUtil";
import DateUtil from "utils/DateUtil";
import StringUtil from "utils/StringUtil";
import UIUtils from "utils/UIUtils";
import message from "common/message/source/MessageSource";
import codeDataStore from "common/codedata/store/CodeDataStore";

function ContentsContainer() { 

	const history = useHistory();
	
	const [repSanPersonId, setRepSanPersonId] = useState('');
	const [stDate, setStDate] = useState(new Date());
	const [enDate, setEnDate] = useState(new Date());
	const [absnItem, setAbsnItem] = useState('');
	const [absnReason, setAbsnReason] = useState('');
	let [absnReasonLen, setAbsnReasonLen] = useState(0);
	const [repSanList, setRepSanList] = useState<any[]>([]);
	const [lengthChk, setLengthChk] = useState<boolean>(true);

	async function initCall() {
		const response:any = await CommonUtil.execute({
			url: 'adm_0101_r001',
			progressBar:true
		}).then((response: any) => {
			const result = response;
			if(result != null) {
				let repSancodeList:{code:string;name:string}[] = [];
				const rec1 = result.REC1;
				if(rec1.length > 0) {
					rec1.forEach((v) => { 
						repSancodeList.push({code:v.PERSON_ID, name:v.PERSON_NM+'('+v.POSI_NM+'/'+v.DEPT_NM+')'});
					});
					
					// @ts-ignore
					repSancodeList.sort((a, b) => {
						const aName = a.name;
						const bName = b.name;
						if(aName > bName) return 1;
						if(aName < bName) return -1;
						if(aName === bName) return 0;
					});
					setRepSanList(repSancodeList);
				}
			}		
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});
	};

	//글자 수 체크 및 입력제한 
	const onTextareaHandler = (v) => {
		if(lengthChk) {
			if(absnReasonLen > 300) {
				setLengthChk(false);
				UIUtils.alert("300자 이하로 입력해 주세요.").then(()=> {
					v = v.substring(0, 300);
					setAbsnReason(v);
					setAbsnReasonLen(v.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length);
					setLengthChk(true);
				});
				return;
			}
			setAbsnReason(v);
			setAbsnReasonLen(v.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length);
		}
	};

	//부재정보 저장
	async function doSave(e) {
		e.preventDefault();		

		const pAbsnItem = StringUtil.defaultString(absnItem);
		const pStDate = DateUtil.toDateFormat(stDate, "YYYY-MM-DD");
		const pEnDate = DateUtil.toDateFormat(enDate, "YYYY-MM-DD");
		const pRepSanPersonId = StringUtil.defaultString(repSanPersonId);
		
		let errChkTitle = '';
		if('' === pAbsnItem) errChkTitle = "부재항목";
		else if('' === pStDate) errChkTitle = "부재기간(시작일)";
		else if('' === pEnDate) errChkTitle = "부재기간(종료일)";
		else if('' === pRepSanPersonId) errChkTitle = "직무대리자";
		if("" !== errChkTitle) {
			await UIUtils.alert(errChkTitle + "은(는) 필수입력입니다.");
			return;
		}

		if(pStDate > pEnDate) errChkTitle = "시작일이 종료일보다 클 수 없습니다";
		if("" !== errChkTitle) {
			await UIUtils.alert(errChkTitle);
			return;
		}

		let param = {
			REP_SAN_PERSON_ID : repSanPersonId
			,ST_DATE : DateUtil.toDateFormat(stDate, "YYYY-MM-DD")
			,EN_DATE : DateUtil.toDateFormat(enDate, "YYYY-MM-DD")
			,ABSN_ITEM : absnItem
			,ABSN_REASON : absnReason
		}

		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))) {
			const response:any = await CommonUtil.execute({
				url: "adm_0101_c001",
				data: param
			}).then((response:any) => {
				if(response.ERR_CD === 'S') {
					UIUtils.alert('정상처리되었습니다.').then(()=>{
						doList();
					});
				}else {
					let errMsg = StringUtil.defaultIfEmpty(response.ERR_MSG, "저장에 실패하였습니다.");
					UIUtils.alert(errMsg).then();
				}
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});
		}
    };

	//목록이동
	async function doList() {
		history.push({
			pathname: "/admin/adm_mypage/adm0100",
			state: {data: {}}
		});
    };

	React.useEffect(() => {
		codeDataStore.read("[AI]");
		initCall();
    },[])

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">마이페이지</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">부재등록</h1>
					<form className="fo fo-col2">
						<div className="fo-item req">
							<p className="fo-key">부재항목</p>
							<div className="fo-value">
								<div className="sl sl-md">
									<UISelect
										className={'w218'}
										value={absnItem}
										valueChanged={(value) => setAbsnItem(value)}
										codeData={codeDataStore.get("[AI]")}
										firstName={"sel"}
									/>
								</div>
							</div>
						</div>
						<div className="fo-item req">
							<p className="fo-key">부재기간</p>
							<div className="fo-value">
								<div className="hz-root hz-gap5">
									<UIDatePicker className="hz-item" value={stDate} valueChanged={(value) => setStDate(value)}/>
									<span className="hz-item">~</span>
									<UIDatePicker className="hz-item" value={enDate} valueChanged={(value) => setEnDate(value)}/>
								</div>
							</div>
						</div>
						<div className="fo-item fo-m-1-4">
							<p className="fo-key">부재사유</p>
							<div className="fo-value">
								<div className="ta w100p">
									<UITextArea className={'ta-ip'} value={absnReason} valueChanged={(value) => onTextareaHandler(value)} attrs={{ rows: 10 }}/>
									<div>
										<p className="tx tx-cp1 mt5">
											<em className="fc-err">{absnReasonLen}</em> Bytes / 
											<em className="fc-err">300</em> Bytes
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="fo-item req">
							<p className="fo-key">직무대리자</p>
							<div className="fo-value">
								<div className="sl sl-md">
									<UISelect
										className={'w320'}
										value={repSanPersonId}
										valueChanged={(value) => setRepSanPersonId(value)}
										codeData={repSanList}
										firstName={"sel"}
									/>
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="pri-o" size="sm" onClick={(e)=> doSave(e)}>저장</Button>
						<Button color="pri-o" size="sm" onClick={()=> doList()}>목록</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;